import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

export function useAffiliates() {
  const client = useApiClientUser()

  async function fetchAffiliates() {
    return client.user
      .settingsControllerGetAffiliates({ secure: true })
      .then((res) => res.data.items)
  }

  const { data: affiliates, isLoading } = useQuery({
    queryKey: ['affiliates'],
    queryFn: fetchAffiliates,
  })

  return {
    affiliates: affiliates ?? [],
    isLoading,
  }
}
